const state = {
  showScanner: false,
};

const getters = {
  getShowScanner(state) {
    return state.showScanner;
  },
};

const mutations = {
  OPEN_SCANNER() {
    state.showScanner = true;
  },
  CLOSE_SCANNER() {
    state.showScanner = false;
  },
};

export default {
  namespaced: "Scanner",
  state,
  mutations,
  getters,
};
